import { getHelpUrl } from '@change-corgi/config/help';
import type { Locale } from '@change-corgi/config/locales';
import type { TranslationKey } from '@change-corgi/core/i18n';
import { translationKey } from '@change-corgi/core/i18n';
import type { PaymentGateway } from '@change-corgi/middle-end-gql-schema';

type Result = {
	gateway: string;
	gatewayLink: string;
	termsOfServiceLink: string;
	privacyPolicyLink: string;
	termsOfServiceLinkText: TranslationKey;
	isSunriseEnabled: boolean;
};

export type PolicyInfoProps = {
	gateway: PaymentGateway;
	useDonationLanguage?: boolean;
	locale?: Locale;
	isSunriseEnabled: boolean;
};

const GATEWAY_LINK_MAPPING: Record<PaymentGateway, Record<'href' | 'label', string>> = {
	STRIPE: { href: 'https://stripe.com/legal/ssa', label: 'Stripe' },
	BRAINTREE: { href: 'https://www.paypal.com/us/legalhub/useragreement-full?locale.x=en_US', label: 'Paypal' },
	DLOCAL: { href: 'https://dlocal.com/legal/terms-and-conditions', label: 'dLocal' },
};

export function usePolicyInfo({ gateway, useDonationLanguage, locale, isSunriseEnabled }: PolicyInfoProps): Result {
	const { label, href } = GATEWAY_LINK_MAPPING[gateway];

	return {
		gateway: label,
		gatewayLink: href,
		termsOfServiceLink:
			useDonationLanguage && locale
				? getHelpUrl(locale, 'foundation-donation-terms-of-service')
				: 'https://www.change.org/policies/terms-of-service#6',
		privacyPolicyLink: 'https://www.change.org/policies/privacy',
		termsOfServiceLinkText: translationKey(
			`corgi.payments.policy_info.terms_of_service${useDonationLanguage ? '_donation' : ''}`,
		),
		isSunriseEnabled,
	};
}
